import moment from 'moment';
import { startPattern } from './constant';

export const startDateForPDFSummaryReport = (date, days) => {
  return moment(date).subtract(days, 'days').format(startPattern);
};
